import React, { useState, useEffect } from 'react'
import { Button, Form, Input, Divider, message } from 'antd';
import { hnrequest } from '@/utils'
import {
    useSearchParams
    // , Link 
} from 'react-router-dom';
import '@wangeditor/editor/dist/css/style.css' // 引入 css
import { Editor, Toolbar } from '@wangeditor/editor-for-react';

const Base64 = {
    encode(str) {
        return btoa(encodeURIComponent(str).replace(/%([0-9A-F]{2})/g, (match, p1) => {
            return String.fromCharCode('0x' + p1);
        }));
    },
    decode(str) {
        return decodeURIComponent(atob(str).split('').map(function (c) {
            return '%' + ('00' + c.charCodeAt(0).toString(16)).slice(-2);
        }).join(''));
    }
};


function Aprodts() {
    const token = localStorage.getItem('hntoken_key')
    const [messageApi, contextHolder] = message.useMessage();
    const [ticks, setticks] = useState([]);

    const [fm] = Form.useForm();
    const [urlp] = useSearchParams()
    console.log(urlp.get("q"), token)
    fm.setFieldValue('pno', urlp.get("q"))


    const onFinish = async (values) => {
        const resc = await hnrequest.post('/pms_prodts_ch', values)
        setticks(resc.ticks)
        messageApi.open({
            type: resc.return_code,
            content: resc.return_msg,
        });

    };
    // const tbnymsg = async () => {
    //     const resc = await hnrequest.post('/p_a_nymsg', { pno: urlp.get("q") })
    //     // resc.return_code === 'success' && setHtml(decodeURIComponent(resc.prodts))
    //     fm.setFieldValue('prodts', encodeURIComponent(resc.prodts))
    //     console.log(resc)
    // }

    // editor 实例



    const [editor, setEditor] = useState(null)                   // JS 语法

    // 编辑器内容
    const [html, setHtml] = useState('暂无信息')

    // 模拟 ajax 请求，异步设置 html



    useEffect(() => {
        async function getau() {
            const res = await hnrequest.post('/pms_prodts', { pno: urlp.get('q') })
            res.return_code === 'success' && setHtml(Base64.decode(res.prodts))

        }
        getau()
    }, [urlp,ticks])




    // 工具栏配置
    const toolbarConfig = {}                        // JS 语法

    // 编辑器配置
    const editorConfig = {                         // JS 语法
        placeholder: '请输入内容...',
        MENU_CONF: {}
    }
    editorConfig.MENU_CONF['uploadImage'] = { server: 'http://api.ddspp.com:30123/v2/?t=up_img&token=' + token, }
    editorConfig.MENU_CONF['uploadVideo'] = {
        server: 'http://api.ddspp.com:30123/v2/?t=up_video&token=' + token,
        maxFileSize: 500 * 1024 * 1024, //  允许最大视频大小500M
    }
    // 及时销毁 editor ，重要！
    useEffect(() => {
        return () => {
            if (editor == null) return
            editor.destroy()
            setEditor(null)

        }
    }, [editor, setEditor])




    return (
        <>
            {contextHolder}

            <div style={{ border: '1px solid #ccc', marginTop: '10px', zIndex: 100 }}>
                <Toolbar
                    editor={editor}
                    defaultConfig={toolbarConfig}
                    mode="default"
                    style={{
                        borderBottom: '1px solid #ccc'
                    }}
                />
                <Editor
                    defaultConfig={editorConfig}
                    value={html}
                    onCreated={setEditor}
                    onChange={editor => {
                        setHtml(editor.getHtml())
                        fm.setFieldValue('prodts', Base64.encode(editor.getHtml()))

                    }

                    }
                    mode="default"
                    style={{ height: '500px', overflowY: 'hidden' }}
                />

            </div>

            <Divider />

            <Form
                name="fm"
                form={fm}
                onFinish={onFinish}
                colon={false}
            >
                <Form.Item name="prodts" hidden={true}  >
                    <Input autoComplete="true"
                    />
                </Form.Item>

                <Form.Item name="pno" hidden={true}>
                    <Input />
                </Form.Item>

                <Form.Item label="">
                    <Button type="primary" htmlType="submit">
                        提 交
                    </Button>

                </Form.Item>
            </Form>

            {/* <div dangerouslySetInnerHTML={{ __html: html }}></div> */}

        </>
    )
}

export default Aprodts